import { Entity } from "./entity";
import { SparepartMake, SparepartStatus, SparepartType } from "./enum-type";

export interface Sparepart extends Entity {
    frenchName: string
    price: string
    unitInStock: number
    minUnitInStock: number
    reference: string
    notificationEnabled: boolean
    sparepartType: SparepartType
    sparepartStatus: SparepartStatus
    sparepartMake: SparepartMake
    command: string
    stockValue: string
    displayName?: string
}

export class SparepartExport {
    parts: Sparepart[];
}

export function getSparepartExport(spareparts: Sparepart[]): SparepartExport {
    const sparepartExport = new SparepartExport();
    sparepartExport.parts = spareparts;
    return sparepartExport;
}